"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

/**
 * SelectField.
 *
 * @function
 * @param {object} props
 * @param {Array<{ value: string, label: string }>} props.items
 * @param {string} props.label
 * @param {boolean} [props.disabled=false]
 * @param {null | { value: string, label: string }} [props.selectedItem=null]
 * @param props.onChange
 * @returns {React.ReactNode}
 * @example
 * // TODO: Write example.
 */
var SelectField = function SelectField(_ref) {
  var items = _ref.items,
      label = _ref.label,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      selectedItem = _ref.selectedItem;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      handleFilter = _useState2[1];

  (0, _react.useEffect)(function () {
    handleFilter(items);
  }, [items]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 1,
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
    disabled: disabled,
    disableClearable: true,
    value: selectedItem,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({}, params, {
        variant: "outlined",
        label: label
      }));
    },
    options: items,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, (0, _extends2["default"])({}, props, {
        key: option.label
      }), option.label);
    },
    onChange: onChange
  }));
};

exports.SelectField = SelectField;
SelectField.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })).isRequired,
  selectedItem: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  }), _propTypes["default"].oneOf([null])]),
  filter: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string.isRequired,
  helperText: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  error: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
};
SelectField.defaultProps = {
  disabled: false,
  selectedItem: null,
  helperText: null,
  error: false
};
var _default = SelectField;
exports["default"] = _default;